import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback } from "react";
import updateAvailability from "../updateAvailability";

const useUpdateAvailability = (
  availabilityID?: string,
  title?: string,
  extraInfo?: string,
  price?: number,
) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState(null);

  const send = useCallback(async () => {
    if (availabilityID == null || title == null || extraInfo == null || price == null)
      return reqState;

    setLoading();
    try {
      await updateAvailability(availabilityID, title, extraInfo, price);
      return setSuccess(null);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [availabilityID, title, extraInfo, price, reqState, setError, setLoading, setSuccess]);

  return { ...reqState, data: reqState.data, send };
};

export default useUpdateAvailability;
